import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function AuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Check if this is a password reset callback
        const type = searchParams.get('type');
        const accessToken = searchParams.get('access_token');
        
        if (type === 'recovery' && accessToken) {
          // This is a password reset callback, redirect to reset password page
          navigate('/auth/reset-password', { replace: true });
          return;
        }

        const { data: { session }, error } = await supabase.auth.getSession();
        if (error) throw error;
        if (session) {
          navigate('/', { replace: true });
        } else {
          // No session found, redirect to sign in
          navigate('/auth/signin', { replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/auth/signin', { replace: true });
      }
    };

    handleCallback();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
        <p className="text-gray-600">{t('signingIn')}</p>
      </div>
    </div>
  );
}